/** Shared matcher for complete triple-backtick blocks in chat transformations. */
export const FENCED_BLOCK = /```([^\n`]*)\r?\n([\s\S]*?)```\r?\n?/g;
